import * as actionTypes from "../../Action/actionTypes";

const initialState = {
  hostMobile: "",
  hostEntity: "",
  hostLoginProcess: false,
  meetingObj: null,
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    // case actionTypes.STORE_HOST_MOBILE:return {...state, hostMobile: action.value,hostLoginProcess: true};
    // case actionTypes.REMOVE_HOST_MOBILE:return {...state, hostMobile: ""};
    // case actionTypes.STORE_HOST_ENTITY:return {...state, hostEntity: action.value};
    // case actionTypes.REMOVE_HOST_ENTITY:return {...state, hostEntity: ""};
    case actionTypes.SET_HOST_CURRENT_MEETING: return{...state, meetingObj: action.value};
    case actionTypes.REMOVE_HOST_CURRENT_MEETING: return{...state, meetingObj: null};
    default:return state;
  }

}

export default reducer;

